import React, { useState } from "react";
import AntiqueSaleBanner from "../components/AntiqueSaleBanner";
import FamiliarQuestionnaire from "../components/FamiliarQuestionnaire";
import EstimationOffer from "../components/EstimationOffer";
import SuccessionSaleBanner from "../components/SuccessionSaleBanner";
import PurchasedItemsGallery from "../components/PurchasedItemsGallery";
import ContactModal from "../components/ContactModal"; // Modale de contact

const EstimationPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <div className="bg-gray-100 min-h-screen py-16 px-8">
            <AntiqueSaleBanner openModal={openModal} />
            <FamiliarQuestionnaire openModal={openModal} />
            <PurchasedItemsGallery openModal={openModal} />
            <EstimationOffer openModal={openModal} />
            <SuccessionSaleBanner openModal={openModal} />

            {/* Modale de contact */}
            <ContactModal isOpen={isModalOpen} onClose={closeModal} />
        </div>
    );
};

export default EstimationPage;
